import React from "react";
import Dropdown from "../DropDown";

interface StatusDropdownProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const StatusDropdown: React.FC<StatusDropdownProps> = ({
  value,
  onChange,
  disabled,
  className = "",
  onFocus,
}) => {
  const options = [
    { value: "Internal", label: "Internal" },
    { value: "ALL", label: "ALL" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={value}
      onValueChange={onChange}
      disabled={disabled}
      className={className}
      placeholder="Select"
      onFocus={onFocus}
    />
  );
};

export default StatusDropdown;
